<template>
    <div id="credits-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="creditsModalLabel"
         aria-hidden="true">

        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">

            <div class="modal-content">

                <div class="close pt-3 pr-3 ">
                    <button type="button" class="close pb-0" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div class="modal-body">
                    <div id="logo-container">
                        <a v-on:click="setAsdlCredits()">
                            <img id="asdlLogo" class="logos" src="../../assets/imgs/credits/asdl_200x200.png"/>
                        </a>
                        <a v-on:click="setYummyCredits()">
                            <img id="yummyLogo" class="logos" style="filter: grayscale(100%)"
                                 src="../../assets/imgs/credits/yummy_200x200.png"/>
                        </a>
                    </div>

                    <transition name="fade">
                        <div class="d-flex flex-column justify-content-center align-items-center py-3 py-lg-5 text-center"
                             v-if="credits && credits.length > 0 && show">

                            <h3 class="pb-3">Credits</h3>

                            <div v-for="(section, sectionIndex) in credits"
                                 class="py-4 d-flex flex-column justify-content-center align-items-center"
                                 v-bind:key="sectionIndex">

                                <h5 v-if="section.name && section.name !== ''" v-text="section.name"
                                    class="pb-3"></h5>

                                <div v-for="(people, peopleIndex) in section.credits_peoples"
                                     v-bind:key="peopleIndex"
                                     class="credits-list d-flex flex-column justify-content-center align-items-center">

                                    <p v-text="people.title" class="title"></p>
                                    <p v-text="people.name" class="name"></p>

                                </div>
                            </div>
                        </div>
                    </transition>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

    const axios = require('axios');

    export default {
        name: "CreditsModal",
        data() {
            return {
                credits: null,
                creditsASDL: [],
                creditsYUMMY: [],
                baseUrl: null,
                show: true
            }
        },
        created() {
            this.baseUrl = this.$cookie.get('base-url');
            this.getCredits();
        },
        methods: {
            getCredits() {

                let self = this;
                let creditsUrl = this.baseUrl + 'api/credits';


                axios.get(creditsUrl)
                    .then(function (response) {
                        self.credits = response.data.result.credits_sections;
                        self.credits.forEach(credit => {
                            if (credit.order_no === 0) {
                                self.creditsASDL.push(credit);
                            } else {
                                self.creditsYUMMY.push(credit);
                            }
                        });
                        self.credits = self.creditsASDL;
                    })
                    .catch(function (error) {
                        console.log('user info error', error);
                    });

            },
            setAsdlCredits() {
                if (this.credits === this.creditsASDL) return;

                this.setGrayscale("yummyLogo", 100);
                this.setGrayscale("asdlLogo", 0);
                this.show = !this.show;
                this.credits = this.creditsASDL;
                setTimeout(() => {
                    this.show = !this.show;
                }, 200);
            },

            setYummyCredits() {
                if (this.credits === this.creditsYUMMY) return;

                this.setGrayscale("yummyLogo", 0);
                this.setGrayscale("asdlLogo", 100);
                this.show = !this.show;
                this.credits = this.creditsYUMMY;
                setTimeout(() => {
                    this.show = !this.show;
                }, 200);

            },

            setGrayscale(logoString, value) {
                const logo = document.getElementById(logoString);
                if (logo) {
                    logo.style.filter = "grayscale(" + value + "%)";
                }
            }
        }
    }
</script>

<style lang="scss">
    @import '../../styles/credits-modal.scss';

    .logos {
        /*margin-left: 2rem;*/
        /*margin-right: 2rem;*/
        display: inline-block;
        max-width: 80%;

    }

    .logos:hover {
        transform-origin: center;
        transform: scale(1.2);
        transition-duration: 500ms;
    }

    #logo-container {
        display: flex;
        text-align: center;
        /*align-items: center;*/
        width: 50%;
        margin-left: auto;
        margin-right: auto;
    }

    .fade-enter-active {
        transition: opacity 1s
    }

    .fade-leave-active {
        transition: opacity 0.2s
    }

    .fade-enter,
    .fade-leave-to {
        opacity: 0
    }


</style>
